// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"69":"participate","94":"collaborators","130":"teaching","286":"lab_news","353":"contact","516":"team"}[chunkId] + "." + {"69":"26c24bdb","94":"cbcc0fa7","130":"82c853da","286":"eeb6853b","353":"7fdb102c","516":"1ab5d8eb"}[chunkId] + ".css";
};